export default __webpack_public_path__ + "static/dooridentify-logo-waynedalton-c4a6a0d3ee5d9c6196f863af996df1e6.png";